import { ActionIcon, Popover, Text } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { IconInfoCircle } from '@tabler/icons-react'

/**
 * The information icon next to a metric or chart: shows the definition text its endpoint
 * returned. It only explains — it never opens a patient list, even inside a clickable card.
 */
export function InfoIcon({ label, definition }: { label: string; definition: string }) {
  // Controlled: an uncontrolled Popover.Target calls the child's onClick without the event,
  // and the click must not reach a clickable card behind the icon.
  const [opened, { toggle, close }] = useDisclosure(false)
  return (
    <Popover
      opened={opened}
      onDismiss={close}
      width={300}
      position="bottom-start"
      withArrow
      shadow="md"
    >
      <Popover.Target>
        <ActionIcon
          variant="subtle"
          color="gray"
          size="sm"
          aria-label={`About ${label}`}
          onClick={(event) => {
            event.stopPropagation()
            toggle()
          }}
        >
          <IconInfoCircle size={16} />
        </ActionIcon>
      </Popover.Target>
      <Popover.Dropdown onClick={(event) => event.stopPropagation()}>
        <Text size="sm">{definition}</Text>
      </Popover.Dropdown>
    </Popover>
  )
}
